export enum OperatingSystem {
  NONE = 'NONE',
  
  WINDOWS_8 = "WINDOWS_8",

  WINDOWS_10 = "WINDOWS_10",

  LINUX = "LINUX",

  OTHERS = "OTHERS",
}
